<template>
  <div id="pk-live">
      <div class="title-box">
          <img src="@/assets/active/team-pk/title-tag.png" alt="">
          <span>{{state === '战队招募完毕' && (countDownObj.day >= 0 && countDownObj.hour >= 0 && countDownObj.minute >= 0 && countDownObj.second >= 0) ? '距离比赛结束还有' : state}}</span>
          <img src="@/assets/active/team-pk/title-tag.png" alt="">
      </div>
      <div class="timer-wrapper" v-show="countDownObj.day >= 0 && countDownObj.hour >= 0 && countDownObj.minute >= 0 && countDownObj.second >= 0">
          <div class="timer-bar">
              <span class="num">{{countDownObj.day}}</span>
              <span>日</span>
              <span class="num">{{countDownObj.hour}}</span>
              <span>时</span>
              <span class="num">{{countDownObj.minute}}</span>
              <span>分</span>
              <span class="num">{{countDownObj.second}}</span>
              <span>秒</span>
          </div>
      </div>
      <div class="date">
          <span>数据更新时间：</span>
          <span>{{ lastTime | parseTime }}</span>
      </div>
      <div class="list-wrapper">
          <div class="list-head clearfix">
                <div class="name left">
                    <span>团队名称</span>
                </div>
                <div class="volume left">
                    <sort-btn sortType='execQuote' sort-name='交易额' @sort='sortListBy' :group-tag='sortGroup' />
                </div>
                <div class="income left">
                    <sort-btn sortType='realized' sort-name='收益额' @sort='sortListBy' :group-tag='sortGroup' />
                </div>
                <div class="incomeRate left">
                    <sort-btn sortType='yieldRate' sort-name='收益率' @sort='sortListBy' :group-tag='sortGroup' />
                </div>
          </div>
          <div class="list-body">
              <ul>
                  <li v-for="item in showList" :key="item.teamId" class="clearfix">
                      <div class="name left">
                        <span>{{ item.name }}</span>
                      </div>
                      <div class="volume left" :class="item.isTopByExecQuote ? 'max' : ''">
                        
                        <span>
                            <img v-if="item.isTopByExecQuote" src="@/assets/active/team-pk/crown.png" alt="">
                            {{ item.execQuote | numberNewFormatter(2) }}
                        </span>
                      </div>
                      <div class="income left" :class="item.isTopByRealized ? 'max' : ''">
                        <span>
                            <img v-if="item.isTopByRealized" src="@/assets/active/team-pk/crown.png" alt="">
                            {{ item.realized | numberNewFormatter(2) }}
                        </span>
                      </div>
                      <div class="incomeRate left" :class="item.isTopByYieldRate ? 'max' : ''">
                        <span>
                            <img v-if="item.isTopByYieldRate" src="@/assets/active/team-pk/crown.png" alt="">
                            {{ item.yieldRate * 100 | toDigit(2) }}%
                        </span>
                      </div>
                  </li>
              </ul>
          </div>
      </div>
      <jgz-loading :loading-show='showLoading'></jgz-loading>
  </div>
</template>

<script>
import SortBtn from '@/components/SortButton.vue'
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'TeamPkLive',
    data() {
        return {
            showLoading: false,
            currentTime: null,
            lastTime: null,
            beginTime: null,
            endTime: null,
            state: null,
            countDownObj: {},
            sort: 'execQuote',
            sortMode: 'desc',
            sortGroup: '',
            orginList: [],
            showList: []
        }
    },
    components: {
        SortBtn,
        JgzLoading
    },
    mounted() {
        this.getList()
        setInterval(() => {
            this.currentTime = Math.round(new Date())
            this.computeCountDown()
        }, 1000);
    },
    methods: {
        //  获取赛况直播内容
        getList() {
            this.$MyAxios.get('/api/trade/teams/rank', {}, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    const data = response.data[0]
                    this.state = data.busStateName
                    this.lastTime = data.awardUpdateDate
                    this.beginTime = data.busStartTimeOne
                    this.endTime = data.busEndTimeOne
                    this.orginList = data.ranks
                    this.showList = [...this.orginList]
                    this.currentTime = Math.round(new Date())
                    this.computeCountDown()
                }
            })
        },
        computeCountDown() {
            const diff = Math.floor((this.endTime - this.currentTime) / 1000)
            const day =  Math.floor(diff / 3600 / 24)
            const hour = Math.floor(diff % (3600 * 24) / 3600)
            const minute = Math.floor(diff % 3600 / 60)
            const second = Math.floor(diff % 60)
            this.countDownObj = {day, hour, minute, second}
        },
        //  排序操作
        sortListBy(sortObj) {
            this.sortGroup = sortObj.sort;
            this.sortMode = sortObj.sortMode;
            
            if(sortObj.sortMode) {
                this.sort = sortObj.sort;
                this.showList.sort((a, b) => {
                    if(this.sortMode === 'desc'){
                        return b[this.sort] - a[this.sort]
                    }else{
                        return a[this.sort] - b[this.sort]
                    }
                })
            }else{
                //  当归为默认的时候 排序也置空
                this.sort = '';
                this.showList = [...this.orginList]
            }
        },
    }
}
</script>

<style lang='less'>
#pk-live {
    padding-bottom: 178px;
    .title-box {
        height: 105px;
        line-height: 105px;
        text-align: center;
        img, span {
            vertical-align: middle;
        }
        img {
            margin: 0 5px;
            width: 44px;
            height: 24px;
        }
        span {
            font-size: 32px;
            color: #33333A;
            font-weight: bold;
        }
    }
    .timer-bar {
        width: 600px;
        height: 88px;
        background: linear-gradient(180deg,#ffa41f, #ff5c2a);
        border-radius: 44px;
        margin: 0 auto;
        color: #FFFFFF;
        line-height: 88px;
        margin-bottom: 50px;
        span {
            font-size: 32px;
            line-height: 36px;
            vertical-align: middle;
            margin-right: 10px;
        }
        .num {
            font-size: 48px;
            font-weight: bold;
            font-family: 'DINPro';
        }
    }
    .date {
        text-align: left;
        padding: 0 30px;
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 20px;
        color: #9598A6;
    }
    .list-wrapper {
        text-align: right;
        span {
            display: inline-block;
        }
        .list-head {
            height: 70px;
            color: #9598A6;
            border-top: 1px solid #EBECF0;
            border-bottom: 1px solid #EBECF0;
            padding: 0 30px;
            line-height: 70px;
            font-size: 24px;
        }
        .list-body {
            padding: 0 20px;
            li {
                padding: 0 10px;
                border-bottom: 1px solid #EBECF0;
                height: 88px;
                line-height: 88px;
                overflow: hidden;
                color: #33333A;
                font-weight: 500;
                div {
                    position: relative;
                    span {
                        position: relative;
                    }
                    img {
                        position: absolute;
                        top: 5px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 26px;
                        height: 20px;
                    }
                    &.max {
                        color: #FFA41F;
                    }
                }
            }
            .name {
                overflow: hidden;
                position: relative;
                span {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .name {
            width: 35%;
            text-align: left;
        }
        .volume {
            width: 24%;
            margin-right: 1%;
        }
        .income {
            width: 19%;
            margin-right: 1%;
        }
        .incomeRate {
            width: 20%;
        }
    }
}
</style>